export const ADD_PERSON = 'page/ADD_PERSON';

export const PERSON_FORM_SUBMIT = 'PERSON_FORM_SUBMIT';
export const PERSON_FORM_SUBMIT_PENDING =
    `${PERSON_FORM_SUBMIT} [pending]` as const;
export const PERSON_FORM_SUBMIT_COMPLETED =
    `${PERSON_FORM_SUBMIT} [success]` as const;
export const PERSON_FORM_SUBMIT_FAIL = `${PERSON_FORM_SUBMIT} [fail]` as const;

export const EDIT_PERSON = 'page/EDIT_PERSON';
export const EDITING_PERSON = 'page/EDITING_PERSON';

export const DELETE_PERSON = 'page/DELETE_PERSON';

export const ADDRESS_FETCH_REQUESTED = 'page/ADDRESS_FETCH_REQUESTED';
export const ADDRESS_FETCH_REQUESTED_PENDING =
    `${ADDRESS_FETCH_REQUESTED} [pending]` as const;
export const ADDRESS_FETCH_REQUESTED_SUCCESS =
    `${ADDRESS_FETCH_REQUESTED} [success]` as const;

export const TOGGLE_MANUAL_ADDRESS_STATE = 'page/TOGGLE_MANUAL_ADDRESS_STATE';
